import { fetchPaymentPlans } from '@/redux/thunks/app.thunk';
import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
export const logout = createAction('auth/logout');

type PaymentPlan = {
  id: string,
  name: string,
  description: string,
  prices: any[],
  created_at: string,
  updated_at: string,
}

interface AppState { 
  loading: boolean;
  data: {
    payments_plans: PaymentPlan[]
  };
}

const initialState: AppState = {
  loading: false,
  data: {
    payments_plans: []
  }
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    clearAppState: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPaymentPlans.pending, (state) => {
      state.loading = true;
    })
    builder.addCase(fetchPaymentPlans.fulfilled, (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.data.payments_plans = action.payload;
    })
    builder.addCase(fetchPaymentPlans.rejected, (state) => {
      state.loading = false;
    })
    builder.addCase(logout, (state) => {
      return initialState;
    })
  }
});

export const { clearAppState } = appSlice.actions;
export default appSlice.reducer;
